import { getDriver } from "@/tours/driverInstance";
import router from '@/router'
import demoImgUrl from '@/assets/img/tour/productSample.png';

export function productListSteps(focusIntoView) {
  const q = (sel) => document.querySelector(sel);
  return [
    {
      element: () => q('[data-tour="dlist.create"]'),
      popover: {
        title: "제품정보 등록",
        side: "center",
        align: "center",
        description: `
          <div style="margin-bottom:32px;"><b>제품정보 등록화면</b>으로 이동합니다.
          </div>
            <div class="driver-popover-footer" style="display:flex; gap:8px; justify-content:end;">
              <button type="button" class="driver-popover-prev-btn" style="display: block;">이전</button>
              <button id="go-register" class="driver-popover-next-btn driver-popover-btn">
                이동
              </button>
            </div>
        `,
        showButtons: []
      },
      onHighlighted: () => {
        const drv = getDriver();
        document.querySelector('#go-register')
          ?.addEventListener('click', () => {
            drv.destroy();
            router.push({ name: 'ProductCreate' ,query: { tour: 'true', view: 'create' } });
          });
      }
    },
  ];
}


export function productCreateSteps(focusIntoView) {
  const q = (sel) => document.querySelector(sel);
  return [
    {
      element: () => q('[data-tour="dcreate.left"]'),
      popover: {
        title: "상세정보 설정",
        side: "right",
        align: "start",
        popoverClass: 'driver-theme-bs popover-offset-r',
        description: `
          <div class="ds-tip" style="margin-bottom:32px;">
            <div class="item"><span class="num">1</span><div class="txt">
              <div class="tit">대표 이미지</div>
              <div class="desc">
                제품을 쉽게 구분할 수 있는 사진을 등록합니다. (선택)<br/>
                예) 제품 정면컷, 패키지 사진, 라벨 이미지<br/>
                ※ JPG/PNG 형식, 10MB 이하 권장
              </div>
            </div></div>

            <div class="item"><span class="num">2</span><div class="txt">
              <div class="tit">카테고리</div>
              <div class="desc">
                제품이 속하는 분류를 선택합니다. 통계·검색·필터에 사용됩니다.<br/>
                예) 안경/액세서리, 생활가전, 식품/음료 등
              </div>
            </div></div>

            <div class="item"><span class="num">3</span><div class="txt">
              <div class="tit">GTIN <small>(Global Trade Item Number)</small></div>
              <div class="desc">
                글로벌 제품 식별 번호를 숫자만 입력합니다. <b>GTIN-14</b> 형식을 지원합니다.<br/>
                예) 08801234567890 (GTIN-14)<br/>
                ※ 숫자만 허용되며, 하이픈/공백은 자동 제거됩니다.
              </div>
            </div></div>

            <div class="item"><span class="num">4</span><div class="txt">
              <div class="tit">제품명</div>
              <div class="desc">
                화면과 문서에 표시될 제품 이름입니다.<br/>
                예) <b>Ultra Lite Glasses</b>, <b>Eco PET Bottle 500ml</b>
              </div>
            </div></div>

            <div class="item"><span class="num">5</span><div class="txt">
              <div class="tit">단위</div>
              <div class="desc">
                재고·거래 단위를 선택합니다.<br/>
                예) <b>EA</b>(개), <b>BOX</b>(박스), <b>SET</b>(세트), <b>KG</b>(킬로그램) 등
              </div>
            </div></div>

            <div class="item"><span class="num">6</span><div class="txt">
              <div class="tit">EPC 타입</div>
              <div class="desc">
                EPC(전자상품코드) 인코딩 방식입니다. 일반 제품은 <b>SGTIN</b>을 사용합니다.<br/>
                SGTIN = GTIN + 일련번호(개체 식별)
              </div>
            </div></div>

            <div class="item"><span class="num">7</span><div class="txt">
              <div class="tit">설명</div>
              <div class="desc">
                제품 특성·용도·주의사항 등을 자유롭게 입력합니다.<br/>
                예) <b>가볍고 내구성이 뛰어난 프레임. 블루라이트 차단 렌즈 호환.</b>
              </div>
            </div></div>
          </div>
          <div class="driver-popover-footer" style="display:flex; gap:8px; justify-content:end;">
            <button type="button" class="driver-popover-prev-btn" style="display: block;">이전</button>
            <button id="auto-input" class="driver-popover-custom-btn driver-popover-btn">
              다음
            </button>
          </div>
        `,
        showButtons: []
      },
      onHighlighted: async () => {
        const drv = getDriver();

        const sleep = (ms) => new Promise(r => setTimeout(r, ms));
        const typeInto = async (el, text, delay = 25) => {
          if (!el) return;
          el.focus();
          el.value = '';
          el.dispatchEvent(new Event('input', { bubbles: true }));
          for (const ch of text) {
            el.value += ch;
            el.dispatchEvent(new Event('input', { bubbles: true }));
            await sleep(delay);
          }
          el.blur();
        };
        const waitFor = async (selector, timeout = 2000) => {
          const start = performance.now();
          while (performance.now() - start < timeout) {
            const el = document.querySelector(selector);
            if (el) return el;
            await sleep(50);
          }
          return null;
        };

        // 실제 옵션이 있는지 확인하고 change/input 이벤트까지 쏴줌
        const setSelectValue = (el, value) => {
          if (!el) return false;
          const match = [...el.options].find(o => String(o.value) === String(value) && !o.disabled);
          if (!match) return false;
          el.value = match.value;
          [...el.options].forEach(o => (o.selected = (o === match)));
          el.dispatchEvent(new Event('change', { bubbles: true }));
          el.dispatchEvent(new Event('input',  { bubbles: true })); // 안전용
          return true;
        };

        const scopeLeft = '[data-tour="dcreate.left"]';
        const $category = await waitFor(`${scopeLeft} select[data-tour="product.category"]`);
        const $unit     = await waitFor(`${scopeLeft} select[data-tour="product.unit"]`);
        const $epcType  = await waitFor(`${scopeLeft} select[data-tour="product.epcType"]`);
        const $gtin     = document.querySelector(`${scopeLeft} input[placeholder^="숫자만 입력"]`);
        const $name     = document.querySelector(`${scopeLeft} input[placeholder="예: Ultra Lite Glasses"]`);
        const $desc     = document.querySelector(`${scopeLeft} textarea[placeholder="제품 설명을 입력하세요."]`);


        const setDemoImage = async (url) => {
          const res = await fetch(url);
          const blob = await res.blob();
          const name = (url.split('/').pop() || 'demo.jpg');
          const file = new File([blob], name, { type: blob.type });
          window.dispatchEvent(new CustomEvent('tour:setImage', { detail: { file, blob, name } }));
        };

        const btn = document.querySelector('#auto-input');
        if (!btn) return;

        // ✅ 기존에 붙은 모든 핸들러 제거(Driver의 기본 next 포함 가능성) + 대체
        const clone = btn.cloneNode(true);
        btn.replaceWith(clone);

        let running = false; // 재진입 가드

        const run = async (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (running) return;          // 이미 실행 중이면 무시
          running = true;

          // UI 잠금
          const prevText = clone.textContent;
          clone.disabled = true;
          clone.classList.add('is-busy');

          try {
            await sleep(50);
            await setDemoImage(demoImgUrl);
            setSelectValue($category, '01') || console.warn('카테고리 01 옵션 없음');
            setSelectValue($unit,     'EA') || console.warn('단위 EA 옵션 없음');
            setSelectValue($epcType,  'SGTIN') || console.warn('EPC SGTIN 옵션 없음');
            await typeInto($gtin, '08801234567890', 10);
            await typeInto($name, 'Ultra Lite Glasses', 10);
            await typeInto($desc, '가볍고 내구성이 뛰어난 프리미엄 안경입니다.', 10);

            await sleep(1700);
            drv.moveNext();            // 완료 후 다음 스텝
          } finally {
            // 필요 시 다시 활성화 (다음 스텝으로 넘어가니 의미 없으면 생략 가능)
            clone.disabled = false;
            clone.textContent = prevText;
            clone.classList.remove('is-busy');
            running = false;
          }
        };

        // 한 개의 리스너만 등록
        clone.addEventListener('click', run);
      }
    },
    {
      element: () => q('[data-tour="dcreate.co2"]'),
      popover: {
        title: "탄소배출량 설정",
        side: "right",
        align: "start",
        description: `
        <ul class="pb-0 ps-3">
          <li><b>슬라이더</b>를 드래그하여 제품의 탄소배출량을 직접 조절할 수 있습니다.</li>
          <li><b>현재 값</b>은 kgCO₂e 단위로 표시되며, 기본 범위는 0 ~ 10kgCO₂e 입니다.</li>
          <li><b>색상 구간</b>은 배출량 수준을 의미합니다. (녹색=낮음, 노랑=보통, 빨강=높음)</li>
        </ul>
        `
      },
      onHighlightStarted: () => focusIntoView('[data-tour="dcreate.co2"]'),
    },
    {
      element: () => q('[data-tour="dcreate.save"]'),
      popover: {
        title: "저장하기",
        side: "top",
        align: "start",
        description: `
        <ul class="pb-0 ps-3">
          <li>해당 내용으로 데이터를 <b>저장</b>합니다.</li>
        </ul>
        `
      },
      onHighlightStarted: () => focusIntoView('[data-tour="dcreate.save"]'),
    },
    {
      element: null,
      popover: {
        title: "다음 가이드로 이동",
        side: "center",
        align: "center",
        description: `
          <div style="margin-bottom:32px;"><b>운송수단 등록메뉴</b>로 이동하시겠어요?</div>
          <div class="driver-popover-footer" style="display:flex; gap:8px; justify-content:center;">
            <button type="button" class="driver-popover-prev-btn" style="display: block;">이전</button>
            <button id="go-register" class="driver-popover-next-btn driver-popover-btn">
              이동
            </button>
          </div>
        `,
        showButtons: []
      },
      onHighlighted: () => {
        const drv = getDriver();
        document.querySelector('#go-register')
          ?.addEventListener('click', () => {
            drv.destroy();
            router.push({ name: 'Vehicles' ,query: { tour: 'true' } });
          });
      }
    },
  ];
}
